export default __webpack_public_path__ + "static/media/Vector-right.3a6503ab.png";